import { ODataSelect } from "@iconics/core";
import { SecurityProviderEnum } from "../../../Providers.LocalStorage/Models";

export interface IIdentityProviderData
{
    ID: number;
    Name: string;
    SecurityProviderTypeId: SecurityProviderEnum;
    ClientId: string | null;
    TenantDomain: string | null;
    TenantId: string | null;
    NameClaimType: string | null;
    IsDefault: boolean;
    TenancyId: string;
}

export interface IAuthenticationResponse
{
    Token: string;
    DisplayName: string;
    UserName: string; 
}

export class User extends ODataSelect
{
    public Email = '';
    public PreferredName: string | null = '';
    public FirstName: string | null = '';
    public LastName: string | null = '';
    public DisplayName: string | null = '';
}